import { useState, useEffect } from "react";
import Sidebar from "./SideBar";
import Topbar from "./TopBar";
import MobileHeader from "./MobileHeader";
import "./layout.scss";
import clsx from "clsx";
import PageTopBar from "../menu/PageTopBar";
//import "./adminlte.css"; // từ template của bạn

export default function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [sidebarOpen, setSidebarOpen] = useState(
    localStorage.getItem("sidebar") === null
      ? true
      : localStorage.getItem("sidebar") === "open"
  );

  // Detect mobile screen
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      // Auto collapse sidebar on mobile
      if (mobile && !collapsed) {
        setCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Check on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleCloseSidebar = () => {
    if (isMobile) {
      setCollapsed(true);
    }
  };

  const handleExpandSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div
      className={clsx(
        "app-wrapper sidebar-expand-lg layout-fixed fixed-header",
        isMobile && !collapsed && "sidebar-open",
        !isMobile && collapsed && "sidebar-collapsed"
      )}
    >
      {/* Desktop Header - hidden on mobile */}
      {!isMobile && <Topbar onToggle={handleToggleSidebar} />}

      {/* Mobile Header - shown only on mobile */}
      {isMobile && <MobileHeader onToggle={handleToggleSidebar} />}

      {/* Mobile overlay */}
      {isMobile && !collapsed && (
        <div className="sidebar-overlay" onClick={handleCloseSidebar}></div>
      )}
      {/*Sidebar*/}
      <aside
        style={{ transition: "width 0.3s ease, margin-left 0.3s ease" }}
        className={clsx(
          "app-sidebar bg-body-secondary shadow",
          collapsed ? "sidebar collapsed" : "sidebar"
        )}
        data-bs-theme="dark"
      >
        <Sidebar onMenuClick={handleCloseSidebar} />
      </aside>
      {/*Sidebar*/}
      {/*App Main*/}
      <main className="app-main" id="main" tabIndex={-1}>
        <PageTopBar handleExpandSidebar={() => handleExpandSidebar()} />
        <div className="container-page-home-page">{children}</div>
      </main>
      {/*App Main*/}
    </div>
  );
}
